import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { DeleteFromWishlistRequest } from '../api/wishlist/deletefromwishlist/deletefromwishlistrequest';
import { DeleteFromWishlistResponse, DeleteFromWishlistResponseDtoImpl } from '../api/wishlist/deletefromwishlist/deletefromwishlistresponse';
import { DeleteFromWishlistBuilder } from '../dto/wishlist/deletefromwishlist/deletefromwishlistbuilder';
import { DeleteFromWishlistDtoImpl } from '../dto/wishlist/deletefromwishlist/deletefromwishlistdto';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class DeleteFromWishlistAPIProcessorImpl extends SixdeeCRBTAPIProcessor<DeleteFromWishlistRequest, DeleteFromWishlistResponse>
{
    private LOGGER: Logger = LogManager.getLogger(DeleteFromWishlistAPIProcessorImpl.name);
    execute(request: DeleteFromWishlistRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new DeleteFromWishlistResponseDtoImpl(APIFeatures.DELETE_FROM_WISHLIST, "Delete from Wishlist Success");
                let deleteFromWishlistDto =  new DeleteFromWishlistDtoImpl();
                deleteFromWishlistDto.setDeletionStatusList(new DeleteFromWishlistBuilder(responseMapper.getResponseMap()).buildAll());
                response.setDeleteFromWishlistDto(deleteFromWishlistDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new DeleteFromWishlistResponseDtoImpl(APIFeatures.DELETE_FROM_WISHLIST, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new DeleteFromWishlistResponseDtoImpl(APIFeatures.DELETE_FROM_WISHLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new DeleteFromWishlistResponseDtoImpl(APIFeatures.DELETE_FROM_WISHLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new DeleteFromWishlistResponseDtoImpl(APIFeatures.DELETE_FROM_WISHLIST, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/deletefromwishlistapiprocessor.tsx